<template>
  <div class="col-xl-10 col-lg-9 d-flex" style="align-items: center">
    <div class="ml-3 dropdown">
      <span
        class="ag-button_text border-0 text-decoration-none"
        style="position: relative; padding-right: 15px; display: inline-block"
      >
        <a
          href="javascript:;"
          style="
            box-shadow: none;
            color: #164b6c;
            text-decoration: underline;
            font-weight: 600;
            margin-left: -10px;
          "
          @click="setCompany"
          >{{ company.companyName }}</a
        >
        <i
          style="
            font-style: normal;
            padding-left: 15px;
            font-size: 25px;
            position: absolute;
            right: -8px;
            top: -7.5px;
          "
          >></i
        >
      </span>
    </div>
    <div class="ml-3 dropdown">
      <!-- <span
        class="ag-button_text border-0 text-decoration-none"
        v-if="agmsBreadcrumbData && agmsBreadcrumbData.site"
      >
        {{ agmsBreadcrumbData.site?.site }}
        <i
          style="
            font-style: normal;
            padding-left: 15px;
            font-size: 25px;
            position: absolute;
            right: -8px;
            top: -7.5px;
          "
          >></i
        >
      </span> -->
      <span
        class="ag-button_text border-0 text-decoration-none"
        style="position: relative; padding-right: 15px; display: inline-block"
      >
        {{ agmsBreadcrumbData.site?.site }}
        <i
          style="
            font-style: normal;
            padding-left: 15px;
            font-size: 25px;
            position: absolute;
            right: -8px;
            top: -7.5px;
          "
          >></i
        >
      </span>
    </div>
    <div class="ml-3 dropdown">
      <span
        class="ag-button_text border-0 text-decoration-none"
        v-if="agmsBreadcrumbData && agmsBreadcrumbData.group"
      >
        {{ agmsBreadcrumbData.group?.group }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { AuthActionTypes } from "@/store/modules/auth/action-types";
import { Roles } from "@/helpers/enums/Roles";

export default {
  computed: {
    // ...mapGetters(["company", "site", "group"]),
    ...mapState({
      company: (state) => state.auth.company,
      agmsBreadcrumbData: (state) => state.general.agmsBreadcrumbData,
    }),
    ...mapGetters(["loggedInUser"]),
  },
  methods: {
    ...mapActions({
      setAgmsBreadcrumbStatus: GeneralActionTypes.SET_AGMS_BREADCRUMB_STATUS,
      setSite: AuthActionTypes.SET_SITE,
      setGroup: AuthActionTypes.SET_GROUP,
    }),
    setCompany() {
      if (this.loggedInUser.role !== Roles.SiteAdmin) {
        this.setSite({});
      }
      this.setGroup({});
      this.setAgmsBreadcrumbStatus(false);
    },
  },
};
</script>

<style lang="scss" scoped></style>
